import React, { useState, useEffect, useRef } from "react";
import { View, Switch } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import config from "../../config/config";
import ListItem from "./ListItem";

function ListItemSwitch({ itemID = false, title, onSwitch, value, displayValues }) {
    const [switchValue, setSwitchValue] = useState(value);
    const isInitialMount = useRef(true);

    const toggleSwitchValue = async () => {
        setSwitchValue((previousState) => !previousState);
    };

    const updateData = async () => {
        if (itemID) {
            await onSwitch.request(itemID, switchValue);
        } else {
            onSwitch(switchValue);
        }
    };

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
        } else {
            updateData();
        }
    }, [switchValue]);

    return (
        <ListItem
            title={title}
            utilityComponent={
                <View style={{ flexDirection: "row", alignItems: "center" }}>
                    <Switch onValueChange={toggleSwitchValue} value={switchValue} trackColor={{ false: config.colors.tertiary, true: config.colors.tertiary }} />
                </View>
            }
        />
    );
}

export default ListItemSwitch;
